/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/api/Url'
], (Url) => {
	const CONTENT_PERSPECTIVE = 'content';

	class ShareFolderActionHandler {
		constructor() {
			this._url = new Url();
		}

		execute(context) {
			return this._url.getPathRef(context.glassContext, context.urlMap.objRef).then((pathRef)=>{
				return {
					perspective: CONTENT_PERSPECTIVE,
					folder: pathRef
				};
			});
		}

		isVisible(context) {
			return context.target.itemId === 'com.ibm.bi.glass.common.shareContextual';
		}

	}

	return ShareFolderActionHandler;
});